<script>
  import { t } from "../../../core";
</script>

<div class="current-schedule-legend">
  <div class="current-schedule-legend__item">
    <span class="current-schedule-legend__item-img expected" />
    {t("SchedulePanel.Legend.Expected")}
  </div>

  <div class="current-schedule-legend__item">
    <span class="current-schedule-legend__item-img real" />
    {t("SchedulePanel.Legend.Real")}
  </div>

  <div class="current-schedule-legend__item">
    <span class="current-schedule-legend__item-img delay" />
    {t("SchedulePanel.Legend.Delay")}
  </div>
</div>

<style lang="scss">
  .current-schedule-legend {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    column-gap: 3px;

    &__item {
      display: flex;
      align-items: center;
      font-size: 10px;
      margin-bottom: 5px;
    }

    &__item-img {
      display: inline-block;
      margin-right: 5px;
      width: 12px;
      height: 12px;
    }
  }

  .expected {
    background-color: #a7a7a7;
  }
  .delay {
    background-color: #942810;
  }
  .real {
    background-color: #002c64;
  }
</style>
